export const RAFFLE_GROUP_STATUS = {
  /** 활성화된 그룹 */
  ACTIVATE: 'ACTIVATE',
  /** 비활성화된 그룹 */
  DEACTIVATE: 'DEACTIVATE',
  /** 상태 미지정 */
  RAFFLE_GROUP_STATUS_UNSPECIFIED: 'RAFFLE_GROUP_STATUS_UNSPECIFIED',
} as const;

export const RAFFLE_EVENT_STATUS = {
  /** 대기중 */
  PENDING: 'PENDING',
  /** 예약됨 */
  SCHEDULED: 'SCHEDULED',
  /** 진행중 */
  IN_PROGRESS: 'IN_PROGRESS',
  /** 완료됨 */
  COMPLETED: 'COMPLETED',
  /** 상태 미지정 */
  RAFFLE_EVENT_STATUS_UNSPECIFIED: 'RAFFLE_EVENT_STATUS_UNSPECIFIED',
} as const;

export type RaffleEventStatus = typeof RAFFLE_EVENT_STATUS[keyof typeof RAFFLE_EVENT_STATUS];

export type RaffleEventState = 'ACTIVE' | 'DELETED' | 'RAFFLE_EVENT_STATE_UNSPECIFIED';

export type RaffleGroupStatus = typeof RAFFLE_GROUP_STATUS[keyof typeof RAFFLE_GROUP_STATUS];

export type WinningRateSetting = 'AUTO' | 'MANUAL' | 'WINNING_RATE_SETTING_UNSPECIFIED';

export type IssueFailurePolicy =
  | 'WINNING_RATE_AUTO_REBALANCE'
  | 'REPLACE_NON_BENEFIT'
  | 'ISSUE_FAILURE_POLICY_UNSPECIFIED';

export type RafflePrizeOptionType =
  | 'COUPON_MOLD'
  | 'NONE'
  | 'RAFFLE_PRIZE_OPTION_TYPE_UNSPECIFIED';

export type RafflePrizeOptionState =
  | 'ACTIVE'
  | 'DELETED'
  | 'RAFFLE_PRIZE_OPTION_STATE_UNSPECIFIED';


export type RaffleEntryResult =
  | 'WIN'
  | 'LOSS'
  | 'DUPLICATE'
  | 'BEFORE_START'
  | 'CLOSED';

export const RAFFLE_GROUP_STATUS_LOOKUP: { [key in RaffleGroupStatus]: string } = {
  [RAFFLE_GROUP_STATUS.ACTIVATE]: '활성화',
  [RAFFLE_GROUP_STATUS.DEACTIVATE]: '비활성화',
  [RAFFLE_GROUP_STATUS.RAFFLE_GROUP_STATUS_UNSPECIFIED]: '상태 미지정',
};

export const RAFFLE_EVENT_STATUS_LOOKUP: { [key in RaffleEventStatus]: string } = {
  [RAFFLE_EVENT_STATUS.PENDING]: '대기중',
  [RAFFLE_EVENT_STATUS.SCHEDULED]: '예약됨',
  [RAFFLE_EVENT_STATUS.IN_PROGRESS]: '진행중',
  [RAFFLE_EVENT_STATUS.COMPLETED]: '완료',
  [RAFFLE_EVENT_STATUS.RAFFLE_EVENT_STATUS_UNSPECIFIED]: '상태 미지정',
};

export interface CouponMold {
  id: string;
  name: string;
  isValid: boolean;
}

export interface PrizeOption {
  id: string;
  eventId: string;
  type: RafflePrizeOptionType;
  state: RafflePrizeOptionState;
  winningRate: number;
  couponMold: CouponMold;
}

export interface RaffleEvent {
  id: string;
  groupId: string;
  startAt: string;
  endAt: string;
  status: RaffleEventStatus;
  state: RaffleEventState;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  winningRateSetting: WinningRateSetting;
  issueFailurePolicy: IssueFailurePolicy;
  openedImageUrl: string;
  openedVideoUrl?: string;
  closedImageUrl: string;
  closedVideoUrl?: string;
  buttonText: string;
  prizeOption: PrizeOption[];
}

export interface PageResponse {
  totalElements: number;
  totalPageCount: number;
  currentPage: number;
}

export interface CouponRaffleEvent {
  id?: string;
  groupId?: string;
  startAt?: string;
  endAt?: string;
  status?: RaffleEventStatus;
  state?: RaffleEventState;
  imageUrl: string;
  videoUrl?: string;
  buttonText?: string;
}

export interface RepresentativeRaffleEvent {
  couponRaffleEvent: CouponRaffleEvent;
  isEnterable: boolean;
}

export interface RaffleEntryResponse {
  result: RaffleEntryResult;
  couponMold: {
    id: string,
    name: string,
  };
}

export interface RaffleGroup {
  id: string;
  name: string;
  teaserImageUrl: string;
  teaserVideoUrl?: string;
  status: RaffleGroupStatus;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export interface RaffleGroupDetail {
  group: RaffleGroup;
  events: RaffleEvent[];
}
